import React, { useState } from 'react';
import {
  Typography,
  Input,
  FormField,
  InputGroup,
  Textarea,
  PasswordInput,
  OtpInput,
  Select,
  Row as GridRow,
  Col,
} from 'design-system';
import { EnvelopeIcon } from '../../../design-system/components/Icons';
import { CURRENCY_CODE_OPTIONS, PHONE_AFFIX_SELECT_OPTIONS } from './inputShowcaseData';

const Separator = ({ className = '' }) => (
  <div className={['separator', className].filter(Boolean).join(' ')} />
);

export default function InputShowcase() {
  const [fieldInputValue, setFieldInputValue] = useState('');
  const [fieldKitWordValue, setFieldKitWordValue] = useState('');
  const [demoAmountCurrency, setDemoAmountCurrency] = useState('GBP');
  const [demoAmountValue, setDemoAmountValue] = useState('');
  const [demoPhonePrefix, setDemoPhonePrefix] = useState('IN');
  const [demoPhoneNumber, setDemoPhoneNumber] = useState('');
  const [demoOtpPartial, setDemoOtpPartial] = useState('63');
  const [demoOtpEmpty, setDemoOtpEmpty] = useState('');

  return (
    <>
          {/* Input Section */}
          <Col xs={12}>
            <div className="design-system-section">
              <Typography variant="h1" className="section-title mb-4">
                Input Components
              </Typography>
              <Separator className="mb-5" />
              <Typography variant="body2" color="muted" className="mb-3">
                Interactive example
              </Typography>
              <FormField className="ds-form-field--width-md" label="Label">
                <Input
                  placeholder="Enter Input"
                  value={fieldInputValue}
                  onChange={(e) => setFieldInputValue(e.target.value)}
                />
              </FormField>

              <Separator className="my-4" />
              <Typography variant="body2" color="muted" className="mb-2">
                States (static previews — hover/focus use doc-only classes)
              </Typography>
              <GridRow className="mb-4">
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input without data
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field without data
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label">
                    <Input readOnly placeholder="Enter Input" value="" />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input data hover
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field without data hover
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label">
                    <div className="ds-input-preview--hover-simulate">
                      <Input readOnly placeholder="Enter Input" value="" />
                    </div>
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input with ongoing data
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with ongoing data
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label">
                    <div className="ds-input-preview--focus-simulate">
                      <Input readOnly value="Enter Input" />
                    </div>
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input with data
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with data
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label">
                    <Input readOnly value="Username34" />
                  </FormField>
                </Col>
              </GridRow>

              <Separator className="my-4" />
              <Typography variant="body2" color="muted" className="mb-2">
                Help text variants
              </Typography>
              <GridRow className="mb-4">
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + help text
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <Input readOnly placeholder="Enter Input" value="" />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + help text ongoing data
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text + ongoing data
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <div className="ds-input-preview--focus-simulate">
                      <Input readOnly value="Enter Input" />
                    </div>
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + successful help text
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with successful help text
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text" success>
                    <Input readOnly success value="Enter Input" />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + unsuccessful help text
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with unsuccessful help text
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required errorText="Help Text">
                    <Input readOnly error value="Enter Input" />
                  </FormField>
                </Col>
              </GridRow>

              <Separator className="my-4" />
              <Typography variant="body2" color="muted" className="mb-2">
                Affix row
              </Typography>
              <GridRow className="mb-4">
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + mandatory + word limit
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text + mandatory + word limit
                  </Typography>
                  <FormField
                    className="ds-form-field--width-md"
                    label="Label"
                    required
                    helperText="Help Text"
                    characterCount={{ current: fieldKitWordValue.length, max: 250 }}
                  >
                    <Input
                      placeholder="Enter Input"
                      value={fieldKitWordValue}
                      onChange={(e) => setFieldKitWordValue(e.target.value)}
                      maxLength={250}
                    />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + icon
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text with icon
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <InputGroup prefix={<EnvelopeIcon size={20} fill="var(--ds-color-gray-600)" />}>
                      <Input placeholder="Enter Input" />
                    </InputGroup>
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + website
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text with website
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <InputGroup prefixText="Http://">
                      <Input placeholder="Enter Link" />
                    </InputGroup>
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + amount
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text with amount (<code>Input</code> <code>amount</code> — digits / one
                    decimal only)
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <InputGroup
                      prefixText="£"
                      suffix={
                        <Select
                          variant="affix"
                          align="right"
                          options={CURRENCY_CODE_OPTIONS}
                          value={demoAmountCurrency}
                          onChange={setDemoAmountCurrency}
                          ariaLabel="Currency"
                        />
                      }
                    >
                      <Input
                        amount
                        type="text"
                        placeholder="Enter Amount"
                        value={demoAmountValue}
                        onChange={(e) => setDemoAmountValue(e.target.value)}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </FormField>
                </Col>
              </GridRow>

              <Separator className="my-4" />
              <GridRow className="mb-4">
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + phone number
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text with phone number
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <InputGroup
                      prefix={
                        <Select
                          variant="affix"
                          align="left"
                          options={PHONE_AFFIX_SELECT_OPTIONS}
                          value={demoPhonePrefix}
                          onChange={setDemoPhonePrefix}
                          ariaLabel="Country code"
                        />
                      }
                    >
                      <Input
                        phone
                        placeholder="Enter Number"
                        value={demoPhoneNumber}
                        onChange={(e) => setDemoPhoneNumber(e.target.value)}
                        autoComplete="tel"
                      />
                    </InputGroup>
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + passwords (visible)
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text with password
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <PasswordInput defaultVisible placeholder="Enter Password" value="secret12" readOnly />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + passwords (masked)
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Input Field with help text with password
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <PasswordInput placeholder="Enter Password" value="secret12" readOnly />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + multiline
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Textarea with help text
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <Textarea placeholder="Enter Text" rows={4} />
                  </FormField>
                </Col>
              </GridRow>

              <Separator className="my-4" />
              <Typography variant="body2" color="muted" className="mb-2">
                OTP
              </Typography>
              <GridRow className="mb-2">
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + OTP (empty)
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Interactive — starts empty; digits appear as you type
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <OtpInput length={5} value={demoOtpEmpty} onChange={setDemoOtpEmpty} />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + OTP (ongoing)
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Partial entry — third cell styled as focused (preview)
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text">
                    <div className="ds-otp-preview--focus-cell-3">
                      <OtpInput length={5} value={demoOtpPartial} onChange={setDemoOtpPartial} />
                    </div>
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + OTP (success)
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    All digits entered — success styling
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required helperText="Help Text" success>
                    <OtpInput length={5} value="63209" success onChange={() => {}} />
                  </FormField>
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <Typography variant="body2" color="muted" className="mb-2">
                    Input + OTP (error)
                  </Typography>
                  <Typography variant="captionMedium" color="muted" className="mb-2 d-block">
                    Invalid code — error styling
                  </Typography>
                  <FormField className="ds-form-field--width-md" label="Label" required errorText="Help Text">
                    <OtpInput length={5} value="63209" onChange={() => {}} error />
                  </FormField>
                </Col>
              </GridRow>
            </div>
          </Col>
    </>
  );
}